module.exports = __webpack_public_path__ + "media/banners/cuk-logo-ebea5609.png";